export default {
  tutor: {
    TutorName: '导师姓名',
    TutorMobile: '导师手机',
    TutorWeChat: '导师微信号',
    UserStatus: '用户状态',
    OnlineStatus: '在线状态',
    OnLine: '在线',
    OffLine: '离线',
    ChooseTutor: '选择导师'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/myg/tutor.js